import { CAccordion, CAvatar, CButton, CModal, CModalBody, CModalFooter, CProgress, CProgressBar, CTable, CTableBody, CTableDataCell, CTableRow } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useIndexedDB } from '../../context/IndexedContext'
import { Download, HardDriveUpload, Loader2, Upload } from 'lucide-react'
import GetPatientAllergiesCRUD from '../../services/general/getPatientAllergies.api'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import { getAllAppointments, getAllAppointmentsDetails, getAppointmentDataID } from '../../components/shared/appointmentFilterData'
import PatientAppointmentDetails from '../../services/general/appointmentData.api'
import FacilityCRUD from '../../services/general/getFacilityData.api'
import SavePatients from '../../services/general/savePatientinformation.api'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api'
import PatientSuperBillData from '../../services/general/patientSuperBill.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import SaveExtra from '../../services/general/saveExtraData.api'
import PatientPhysicalExaminationData from '../../services/general/physicalExaminationData.api'
import logo from '../../assets/images/avatars/logo3.png'
import PatientReportCRUD from '../../services/general/patientReportCrud.api'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'
 
const UploadOpenChartPatient = ({refreshPage}) => {
  const { getOfflineData, getProviderList, getProviderDetails, saveOfflineData, getAllAppointmentData, getPatientHpi, getAllTodaysAppointment, saveAllTodaysAppointment , getNewPatientData , getOpenChartOfflineData , saveOpenChartOfflineData  } = useIndexedDB()
  const noteStructureRef = useRef({})
  const [masterData, setMasterData] = useState({})
  const [loggedUserProviderId, setLoggedUserProvider] = useState(null)
  const [uploadPatientData, setUploadPatientData] = useState([])
  const [patients, setPatients] = useState([])
  const [selectedPatientId, setSelectedPatientId] = useState(null)
  const [downloadingData, setDownloadingData] = useState(false)
  const [progress, setProgress] = useState(0)




  const getProvidersMaster = async () => {
    try {
      const getProviderDetailsData = await getProviderDetails()
      const data = await getOpenChartOfflineData()
      const DBData = data[getProviderDetailsData?.ID] || []

      const signedPatients = Object.values(DBData)?.filter((item) => item?.newlyAddedData?.currentNote?.status === 'Signed' && !item?.isUploaded)
      const patientData = signedPatients.map((item) => item?.patientData)
      console.log(DBData, signedPatients, patientData, 'maseter data')
      setLoggedUserProvider(getProviderDetailsData || {})
      setMasterData(DBData)
      setUploadPatientData(signedPatients)
      setPatients(patientData)
    } catch (error) {
      console.log(error, 'error data')
    } finally {
      
    }
  }


 
  useEffect(()=>{
     getProvidersMaster()
  },[refreshPage])


  const findPatientData = async (ID) => {
    const data = await uploadPatientData.filter((item) => item?.patientData?.PatientID === ID)
    return data
  }

  const fetchAllergies = async (patientID) => {
    try {
      let formattedData
      let withoutSorted
      formattedData = await GetPatientAllergiesCRUD('GET', patientID)
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        withoutSorted = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }
      // formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date));
      // setAllergiesList(formattedData?.reverse())
      return formattedData?.reverse()
    } catch (error) {
      console.log(error)
      toast.error('Error fetching allergies', toastConfig)
    }
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const formatDate = (date) => {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  //auto schedule

  const [facilities, setFacilities] = useState([])
  const [addedInsurances, setAddedInsurances] = useState([])
  const [appointments, setAppointments] = useState([])
  const [daysMap, setDaysMap] = useState({})
  const [locations, setLocations] = useState([])
  const allData = useRef({})

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
      }))
      setFacilities(formattedData)
    } catch (e) {}
  }

  const getSuperBillData = async (patientID) => {
    try {
      let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientID.toString())
      data = JSON.parse(data?.d)?.Data || []

      if (data?.length) {
        data = data.map((item) => ({
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }))
      }

      const lastItem = data?.at(-1)?.Data?.followUpTime ?? null
      console.log('get data ======> lastItem', lastItem, data)

      return lastItem
    } catch (error) {
      console.error('Error fetching Super Bill data:', error)
    }
  }

  const patientSelectedFacility = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)

      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) {}
  }

  const handleUpdatePatientStatus = async (customData) => {
    try {
      let a = {}
      let facility = await patientSelectedFacility(customData)

      try {
        a['FacilityID'] = facility?.value.toString() || ''
        a['FacilityName'] = facility?.label.toString() || ''
        a['Room'] = customData?.Room?.toString() || ''
      } catch (e) {
        a['FacilityID'] = ''
        a['FacilityName'] = ''
        a['Room'] = -1
      }

      const updateStatus = {
        ...customData,
        Status: 'Follow Up',
      }

      // let allDiagnosis = allSelectedDiagnosis.map(obj => { return obj.label }).join(",");

      let allDiagnosis = customData?.Diagnosis || ''

      let insurances = addedInsurances.map((ins) => ({
        InsuranceID: ins?.ID,
      }))
      console.log('updateStatus===>', updateStatus, insurances, allDiagnosis, facility, a)
      let savePatientInfo
      if (updateStatus?.PatientID && updateStatus?.PatientID !== '') {
        savePatientInfo = SavePatients('Update', JSON.stringify(updateStatus), JSON.stringify(a), allDiagnosis, updateStatus?.PatientID, JSON.stringify(insurances))
      } else {
        console.log('patientId Not Found', updateStatus)
      }

      await savePatientInfo

      // await patientDataFn()
    } catch (error) {
      console.log('error while updating patient Status', error)
    }
    // resetStates()
  }

  const handleAppointmentSubmit = async (appointmentID, patient, appointments ) => {

    
    try {
      const updatePaitent = await handleUpdatePatientStatus(patient)
      console.log("appointments data-->", appointments , appointmentID)
      const appointmentData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
      const appointment = appointmentData.length > 0 ? appointmentData[0] : []
      const groupedData = []
      let latestData
      if (appointmentData.length > 0) {
        latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)
      } else {
        toast.error('No data found', appointmentData)
        return false
      }

      let appointmentFilterData = latestData.map((item) => {
        if (item.data.AppointmentID === appointmentID) {
          const now = new Date()
          const formattedEndDate = now
            .toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
            .replace(',', '')
          return {
            ...item,
            data: {
              ...item.data,
              Status: 'Signed',
              EndTimezone: formattedEndDate,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })
      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)

      if (ID) {
        await PatientAppointmentDetails('UPDATE', ID, appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value, JSON.stringify(groupedData))
        return true
      } else {
        toast.error('Appointment ID note found', toastConfig)
        return false
      }
    } catch (error) {
       console.log("error while appointment ",error )
      toast.error('Failed to save', toastConfig)
      return false
    }
  }

  const getProviders = async () => {
    let data = await getProviderList()

    console.log('provider List ', data)
    let providerData = data

    const daysMap = {}
    const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

    // newProviders.forEach((provider) => {
    providerData?.forEach((provider) => {
      let parsedCapacity = null
      try {
        if (provider?.ProviderData && provider.ProviderData !== 'undefined') {
          parsedCapacity = JSON.parse(provider.ProviderData)
        }
      } catch (error) {
        console.error('Invalid JSON in ProviderData:', provider.ProviderData, error)
        parsedCapacity = null
      }

      allDays.forEach((day) => {
        if (!daysMap[day]) daysMap[day] = []

        let providerEntry = daysMap[day].find((p) => p.ID === provider.ID)

        if (!providerEntry) {
          providerEntry = {
            ID: provider.ID,
            Name: provider.Name,
            Gender: provider.Gender,
            DOB: provider.DOB,
            Address: provider.Address,
            AddressDetails: provider.AddressDetails,
            Lat: provider.Lat,
            Lng: provider.Lng,
            Insurances: provider.Insurances,
            Facilities: [],
            Capacity: parsedCapacity,
          }
          daysMap[day].push(providerEntry)
        }

        provider.Facilities.forEach((facility) => {
          providerEntry.Facilities.push(facility)
        })
      })
    })

    setDaysMap(daysMap)
    return providerData
  }

  const getFacilitiesAppointment = async () => {
    let facilities = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(facilities.d)

    facilities = data.Data
    facilities = facilities.filter((obj) => {
      if (obj.Days && obj.Days != '') {
        return obj
      }
    })
    setLocations(facilities)
  }

  const handleSubmit = async (updateData, apiCallType, selectedAppointments, type = null) => {
    console.log('update data ', updateData)
    try {
      // setIsPageLoading(true)

      const groupedData = []

      updateData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      console.log('Grouped Appointments ===>', groupedData)
      const appointmentData = selectedAppointments
      if (apiCallType == 'UPDATE') {
        console.log('Update data', apiCallType, appointmentData)
        const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', appointmentData?.data?.StartTime.split(' ')[0], appointmentData?.current?.Provider?.value)
        await PatientAppointmentDetails('UPDATE', ID, appointmentData?.data?.StartTime.split(' ')[0], appointmentData?.current?.Provider?.value, JSON.stringify(groupedData))
      } else {
        console.log('INSERT', apiCallType, appointmentData)
        await PatientAppointmentDetails('INSERT', '', appointmentData?.data?.StartTime.split(' ')[0], appointmentData?.current?.Provider?.value, JSON.stringify(groupedData))
      }

      // toast.success('Patient Auto Scheduled  Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to Auto Scheduled', toastConfig)
      console.log('error-->', error)
      // setIsPageLoading(false)
    }
  }

  const handleSchedule = async (props, patient, oldData) => {
    if (!props?.StartTime || !props?.EndTime) return

    try {
      let scheduleAppointmentTime = await getSuperBillData(patient.PatientID)
      console.log('SuperBill schedule data:', scheduleAppointmentTime)

      const weeksMatch = scheduleAppointmentTime?.match(/(\d+)\s*week/i)
      const weeksToAdd = weeksMatch ? parseInt(weeksMatch[1], 10) : 1

      let startTime = new Date(props.StartTime)
      let targetDate = new Date(startTime)
      targetDate.setDate(targetDate.getDate() + weeksToAdd * 7)

      console.log('Target date:', targetDate)

      const dayOptions = { weekday: 'long' }
      const day = targetDate.toLocaleDateString('en-US', dayOptions)

      const allDayData = daysMap[day]

      console.log('day=>', day, allDayData, daysMap)
      if (!allDayData) {
        console.warn(`No data found for ${day}.`)
        alert('No schedule available for this day.')
        return
      }

      allDayData.forEach((obj) => {
        obj.Facilities.forEach((facility) => {
          let tempFacility = locations.find((o) => o.ID == facility.FacilityID)
          facility['Name'] = tempFacility?.Name || ''
          facility['Type'] = tempFacility?.Type || ''
        })
      })

      const providerInfo = allDayData.filter((obj) => obj.Facilities.some((facility) => facility.Name === patient.FacilityName))

      console.log('providerInfo', providerInfo, patient.FacilityName, day, allDayData, oldData)

      if (providerInfo.length === 0) {
        console.warn(`No provider assigned to ${patient.FacilityName} on ${day}.`)
        alert(`No providers are currently assigned to ${patient.FacilityName} on ${day}.`)
        return
      }

      let provider = providerInfo.find((item) => item?.ID === oldData?.current?.Provider?.value)
      if (!provider) provider = providerInfo[0]

      allData.current.Provider = {
        value: provider?.ID,
        label: provider?.Name,
      }

      return targetDate
    } catch (e) {
      console.error('Error processing schedule:', e)
    }
  }

  const handleAutoSchedule = async (item, appointmentID , appointments) => {
    console.log('item-->', item, appointmentID)
    const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
    let patientInsurance = await PatientInsuranceFn('SELECT', '', item.PatientID)
    let tempAppointments = []
    let Insurance = {}
    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
      if (patientInsurance.length > 0) {
        Insurance = JSON.parse(patientInsurance[0].InsuranceDetails)
        Insurance = Insurance[0] || {}
      }
      console.log('patientInsurance=====>', patientInsurance, Insurance)
    } catch (e) {}
    try {
      let getPatientTime = await PatientNoteDataCRUD('GET', item.PatientID)
      getPatientTime = JSON.parse(getPatientTime.d)?.Data
      getPatientTime = getPatientTime.map((entry) => ({
        ...entry,
        getPatientTime: entry.getPatientTime ? JSON.parse(entry.getPatientTime) : {},
      }))
      if (getPatientTime) {
        console.log('filterForStatus', getPatientTime)

        let rawDate = getPatientTime.length > 0 ? getPatientTime[0].date : new Date().toISOString().split('T')[0]
        console.log('filterForStatus', getPatientTime, rawDate, appointmentFilterData)
        let formattedDate = rawDate.replaceAll('.', '/')

        let props = {
          StartTime: appointmentFilterData.length > 0 ? appointmentFilterData[0]?.data.StartTime : formattedDate,
          EndTime: formattedDate,
          PatientID: item.PatientID,
        }

        // let filtered = await getAppointmentForAutoSchedule()
        let filtered = await getAllAppointments('GET')
        // let filtered await PatientAppointmentDetails('UPDATE', ID, selectDate, providerID, JSON.stringify(groupedData))

        let oldData
        if (filtered.length > 0) {
          filtered = filtered.filter((entry) => entry.patientID === item.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Signed' || appt.data?.Status === 'Finish'))
          console.log('filter data ', filtered)
          oldData = filtered[0]?.appointmentDetails?.at(-1)
        }
        console.log('filterForStatus,oldData', filtered, oldData)

        if (oldData?.data?.isInFacility === false) {
          alert(`Patient ${item.FirstName} ${item.LastName || ''} is not in the facility and cannot be scheduled.`)
          return
        }
        let updateOtherDetails = {}

        const priorAuth = oldData?.data?.otherDetails?.priorAuth
        console.log('Updated priorAuth:', updateOtherDetails, priorAuth, oldData)
        if (priorAuth?.isRequired) {
          let noOfTimes = parseInt(priorAuth?.details?.noOfTimes, 10)

          if (isNaN(noOfTimes) || noOfTimes <= 0) {
            alert(`Patient ${item.FirstName} ${item.LastName || ''} has no remaining prior auth and cannot be scheduled.`)
            if (oldData?.data) {
              oldData.data.isInFacility = false
            }
            return
          } else {
            updateOtherDetails = {
              ...oldData.data.otherDetails,
              priorAuth: {
                ...priorAuth,
                details: {
                  ...priorAuth.details,
                  noOfTimes: `${noOfTimes - 1}`,
                },
              },
            }

            console.log('Updated priorAuth:', updateOtherDetails)
          }
        }

        let scheduledDate = await handleSchedule(props, item, oldData)
        let organizeDate = formatDate(scheduledDate)

        let facility = locations?.find((facility) => facility.Name === item.FacilityName)

        let localPatient = { value: item.PatientID, label: `${item.FirstName} ${item.LastName}` }
        let localFacility = { value: facility?.ID, label: facility?.Name }
        let localProvider = allData.current?.Provider || {}

        let data = {
          AppointmentName: `${item.FirstName} ${item.LastName}`,
          StartTime: organizeDate,
          EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
          PatientID: item.PatientID,
          StartTimezone: null,
          EndTimezone: null,
          Facility: facility?.Name || '',
          Insurance: Insurance || {},
          Status: 'Scheduled',
          Notes: '',
          RoomNumber: item.Room,
          RecurrenceRule: '',
          VisitReason: 'F/U (Follow Up)',
          isInFacility: oldData ? oldData?.data?.isInFacility || true : true,
          otherDetails: oldData ? updateOtherDetails || {} : {},
          AppointmentID: Date.now(),
          ProviderName: localProvider?.label || '',
          ScheduleBy: 'auto-manuel',

          // PatientStatus: filtered.length > 0 ? 'Follow Up' :  item?.Status || 'NewPatient'
          Type: 'Follow Up',
          CreatedDate: new Date(),
          patientSeen: oldData ? oldData?.data?.patientSeen : true,
          notSeenReason: oldData ? oldData?.data?.notSeenReason : '',
          customReason: oldData ? oldData?.data?.customReason : '',

          // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
        }

        let details = {
          data,
          current: {
            Patient: localPatient,
            Facility: localFacility,
            Provider: localProvider,
            Insurance: Insurance,
          },
        }

        tempAppointments.push(details)
      } else {
        console.log('Patient creation failed: Patient date  not found.')
        alert('Patient creation failed: Patient creation date not found. \n Hint: Try using manual-schedule to proceed.')
      }
    } catch (error) {
      console.error('Error fetching patient orders', error)
    }
    console.log('templateAppointments', tempAppointments)
    if (tempAppointments.length > 0) {
      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', tempAppointments[0].data.StartTime.split(' ')[0], tempAppointments[0]?.current?.Provider?.value)
      const apiCallType = latestData.length > 0 ? 'UPDATE' : 'INSERT'
      const combinedAppointments = [...latestData, ...tempAppointments]

      console.log('combined appointment data ', combinedAppointments, apiCallType)
      handleSubmit(combinedAppointments, apiCallType, tempAppointments[0])
    }
  }

  const fetchOrders = async (patientID) => {
    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)

      data = JSON.parse(data?.d).Data || []
      console.log('orders data', data)
      const parsedOrders = data
        ?.map((order) => ({
          // ...order,
          date: order.date,
          medication: JSON.parse(order.medication),
        }))
        .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

      return parsedOrders
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
  }

  const updatePatientUploadStatus = async (patientID) => {
    const data = await getOpenChartOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }

    console.log('orderAllDetials', patientData)

    const updatedPatientData = {
      ...patientData,
      isUploaded: true,
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    console.log('updatedDataSB', updatedData)

    await saveOpenChartOfflineData(updatedData)
    await getProvidersMaster()
  }

  const handleUpdateAppointmentType = async (appoitntmentType) => {
    console.log('appoitntmentType', appoitntmentType)
    try {
      await PatientAppointmentDetails('UPDATE', appoitntmentType.ID, appoitntmentType.ScheduleDate, appoitntmentType.ProviderID, appoitntmentType?.AppointmentDetails, appoitntmentType?.CreatedDate)
    } catch (error) {
      console.error(error)
    }
  }



  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    console.log(allPatientHpiData, 'allPatientHpiData')
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
    return latest || null
  }




  function formatDateFilter(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    return `${mm}/${dd}/${yyyy}`
  }

    const handleAddMedicationData = async (patientID, noteID) => {
      let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      let allData = JSON.parse(data?.d)
  
      const allPatientHpiData = allData?.Data?.map((item) => {
        return {
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })
  
      const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
      console.log(result, 'result[patientID]')
      if (!result) {
        
        // if (patientData?.Status === 'Follow Up' && noteID === 0) {
        if (true) {
          console.log('running the data here')
          const finalHpiStructure = {
            [patientID]: {
              [noteID]: {
                HPI: {},
                medicationRemarksForSubjective: '',
                data: 'Greater than 50% of the total time was spent on coordinating care, reviewing labs, imaging, and speaking with nursing and ancillary staff.',
              },
            },
          }
          console.log(finalHpiStructure, 'insert the data here')
          let data = await SaveExtra('INSERT', 'PatientHPI', JSON.stringify(finalHpiStructure), '')
        }
      } else {
        console.log('insert the data here already')
      }
    }


      const GetPatientTreatmentsNoteID = async (patientID) => {
        try {
          let data
          data = await PatientNoteDataCRUD('GET', patientID)
          if (data) {
            data = JSON.parse(data.d)?.Data
            data = data.map((item) => {
              return {
                ...item,
                data: item.data ? JSON.parse(item?.data) : {},
              }
            })
    
            return data
          }
        } catch (error) {
          toast.error('error in patient treatment', toastConfig)
        } finally {
        }
      }



        const handleAddonAppointmentSubmit = async (updateData, apiCallType = 'INSERT') => {
          try {
           
      
            const groupedData = []
      
            updateData.forEach((entry) => {
              const patientID = entry.current.Patient.value
      
              const existing = groupedData.find((item) => item.patientID === patientID)
      
              if (existing) {
                existing.appointmentDetails.push({ data: entry.data, current: entry.current })
              } else {
                groupedData.push({
                  patientID,
                  appointmentDetails: [{ data: entry.data, current: entry.current }],
                })
              }
            })
      
            const date = formatDateFilter(new Date())
            if (date && loggedUserProviderId?.ID) {
              if (apiCallType == 'UPDATE') {
                const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProviderId?.ID)
                await PatientAppointmentDetails('UPDATE', ID, date, loggedUserProviderId?.ID, JSON.stringify(groupedData))
              } else if (apiCallType == 'INSERT') {
                await PatientAppointmentDetails('INSERT', '', date, loggedUserProviderId?.ID, JSON.stringify(groupedData))
              }
            } else {
              console.error('an error occured while submiting data')
            }
      
            //  toast.success('Created Successfully', toastConfig)
          } catch (error) {
            toast.error('Failed to save', toastConfig)
            console.error('Failed to save ', error)
          } finally {
         
          }
        }
      
        const handleSchdulePatinet = async (noteId, patientData , patinetWithFacilityData) => {
          try {
            let organizeDate = formatDate(new Date())
            let data = {
              AppointmentName: `${patientData.FirstName} ${patientData.LastName}`,
              StartTime: organizeDate,
              EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
              PatientID: patientData.PatientID,
              StartTimezone: null,
              EndTimezone: null,
              Status: 'Scheduled',
              Notes: '',
              RoomNumber: patientData?.Room,
              VisitReason: 'N/P (New Patient)',
              Insurance: {},
              isInFacility: true,
              otherDetails: {},
              Facility: patinetWithFacilityData.label || '',
              ProviderName: loggedUserProviderId?.Name || '',
              AppointmentID: Date.now(),
              ScheduleBy: 'manuel',
              // PatientStatus: filtered.length > 0 ? 'Follow Up' : item?.Status || 'NewPatient'
              Type: 'New',
              CreatedDate: new Date(),
              patientSeen: true,
              notSeenReason: '',
              customReason: '',
              AddedByApp: true,
              NoteID: noteId,
      
              // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
            }
      
            let details = {
              data,
              current: {
                Patient: { value: patientData.PatientID, label: `${patientData.FirstName} ${patientData.LastName}` },
                Facility: patinetWithFacilityData,
                Provider: { value: loggedUserProviderId?.ID, label: loggedUserProviderId?.Name },
              },
            }
      
            if (details) {
              const date = formatDateFilter(new Date())
              const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProviderId?.ID)
              const type = latestData.length > 0 ? 'UPDATE' : 'INSERT'
      
              const combinedAppointments = [...latestData, details]
                
              console.log("combinedAppointments",combinedAppointments )
                
 
               setAppointments((prev)=> [...prev,details ])
             handleAddonAppointmentSubmit(combinedAppointments, type)
             const addedAppointmentData =  {
              combinedAppointments,
              appointmentID : data?.AppointmentID
             }
             return  addedAppointmentData
            }
      
            //  setSelectedPatients([])
          } catch (error) {
            console.log('error while scheduling', error)
          }
        }
      

   const handleSubmitNote = async (patientId , noteStructureData ) => {
    if (!patientId) {
      console.error('patine id not found')
      return null
    }

   
    handleAddMedicationData(patientId, 0)

    const formattedJson = JSON.stringify(noteStructureData.data)
     
     console.log("note formated data " , noteStructureData ,patientId )
    const result = await PatientNoteDataCRUD('INSERT', patientId.toString(), '', formattedJson, getFormattedDate().toString(), 'Submitted', 'true')
    let noteIdForAppointment

    noteIdForAppointment = await GetPatientTreatmentsNoteID(patientId)

   
    return noteIdForAppointment && noteIdForAppointment?.length > 0 && noteIdForAppointment[0]?.id
    
  }
  const uploadPatient = async (ID, useLoaderState = true) => {
    console.log("useLoaderState", useLoaderState)

    if(useLoaderState){
       setDownloadingData(true)
    }
    try {
      const UPdata = await findPatientData(ID)
      if (!UPdata || UPdata.length === 0) {
        toast.info('No local patient data found to upload.', toastConfig)
        setTimeout(() => setDownloadingData(false), 2000)
        return
      }
   
      const fetchUploadData = UPdata[0].newlyAddedData
      console.log('Upload Data:', UPdata, ID, fetchUploadData)
      const getNoteRefData = UPdata[0]?.currentNote
      console.log("find  upload  data ", getNoteRefData , fetchUploadData, UPdata)

       if(UPdata[0]?.details?.AddonPatient){
           const getAddonPatient  = await getNewPatientData()
           let originalPatientId = null
           let appointmentNoteID = null
           let patientNoteID = null
           let todaysAppointmentArray   
            if(getAddonPatient.length > 0){
              const findAddonPaientData = getAddonPatient.find((item) => item?.NewPatientData?.id === ID)
              const insertPatientDetails = findAddonPaientData?.NewPatientData
              console.log("Adddon Patient data",findAddonPaientData )
              let resultData = await SavePatients('Insert', insertPatientDetails?.patientData, insertPatientDetails?.facility, '',  -1, '{}')
               resultData = JSON.parse(resultData.d)

              const newPatientData = resultData?.Data[0]
              const finalPatientID = resultData.Data[0].PatientID
              originalPatientId = resultData.Data[0].PatientID
              const facilityData =  JSON.parse(insertPatientDetails?.facility)
              const facilityObject  =  { value : facilityData?.FacilityID  , label : facilityData?.FacilityName}

              console.log("facilities data ",facilityObject , facilityData )
              if (finalPatientID) {
                  
                const noteIdForAppointment = await handleSubmitNote(finalPatientID , getNoteRefData )
                patientNoteID = noteIdForAppointment
                  console.log("noteIdForAppointment",noteIdForAppointment)
                if (noteIdForAppointment) {
                  const appointmentNoteData =  await handleSchdulePatinet(noteIdForAppointment, newPatientData,facilityObject)
                    appointmentNoteID = appointmentNoteData?.appointmentID
                    todaysAppointmentArray = appointmentNoteData?.combinedAppointments
                   console.log("appointmentNoteID",appointmentNoteID, appointmentNoteData )
                }
              }
                console.log(getAddonPatient,newPatientData,finalPatientID,"getAddonPatient")
            }
          
      
          //REPORT
          const reports = UPdata[0]?.reportData
          const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous']
      const getFileExtension = (file) => {
        if (!file || !file.name) return ''
        return file.name.split('.').pop().toLowerCase()
      }

      Object.entries(reports).forEach(([key, value]) => {
        const filterIsToUpload = value.filter((item) => item.isToUpload)
        console.log(filterIsToUpload, 'filterIsToUpload')
        if (filterIsToUpload.length > 0) {
          filterIsToUpload.forEach(async (fileObj) => {
            try {
              const formData = new FormData()
              const fileObject = fileObj?.data[0].file
              console.log(fileObject, 'fileObject')
              formData.append('file', fileObject)
              formData.append('upload_preset', 'provio')
              formData.append('folder', 'provio')

              // Decide resource type
              let resourceType = 'auto'
              if (getFileExtension(fileObject).includes('pdf') || getFileExtension(fileObject).includes('msword')) {
                resourceType = 'raw'
              }

              // Upload to Cloudinary
              const uploadRes = await fetch(`https://api.cloudinary.com/v1_1/dxayiclcq/${resourceType}/upload`, {
                method: 'POST',
                body: formData,
              })

              const uploadData = await uploadRes.json()

              const uploadedFileUrl = uploadData.secure_url
              const publicId = uploadData.public_id
              let uploadedFileType = uploadData.resource_type
              let assetId = uploadData.asset_id

              const payload = [
                {
                  url: uploadData.secure_url,
                  type: uploadData.resource_type,
                  fileName: fileObject.fileName,
                  id: uploadData.asset_id || Date.now(),
                  publicId: uploadData.public_id,
                },
              ]
              const jsonFormat = JSON.stringify(payload)

              await PatientReportCRUD('INSERT', originalPatientId?.toString(), '', key?.toString(), jsonFormat, getFormattedDate().toString())
            } catch (err) {
              console.error('Upload failed for', fileObj.fileName, err)
            }
          })
        }
        const filterToBeDeleted = value.filter((item) => item.isToBeDeleted)
        console.log(filterToBeDeleted, 'filterToBeDeleted')
        if (filterToBeDeleted.length > 0) {
          filterToBeDeleted.forEach(async (fileObj) => {
            try {
              await PatientReportCRUD('DELETE', originalPatientId?.toString(), fileObj.id)
            } catch (err) {
              console.error('Delete failed for', fileObj.fileName, err)
            }
          })
        }
      })

      // Load Current Note Datas

      if (fetchUploadData?.currentNote) {
        try {
          // const parsed = JSON.parse(fetchUploadData?.currentNote?.formateData)
          const parsed = getNoteRefData.data
          noteStructureRef.current = parsed
        } catch (err) {
          console.error('Error parsing current note:', err)
          toast.error('Failed to parse current note data.', toastConfig)
        }
      }

      console.log('noteStructureRef.current --->', noteStructureRef.current)
      //   Upload Allergies
      if (fetchUploadData?.patientAllergy?.length > 0) {
        try {
          for (const item of fetchUploadData.patientAllergy) {
            await GetPatientAllergiesCRUD('INSERT', originalPatientId?.toString(), item?.data, '', getFormattedDate())

            const allAllergies = await fetchAllergies(originalPatientId)
            console.log('Fetched allergies:', allAllergies)

            if (allAllergies?.length > 0) {
              const lastAllergyId = allAllergies[allAllergies.length - 1]?.id
              if (lastAllergyId) {
                const existingIds = noteStructureRef.current?.metadata?.allergiesIds || []
                const updatedIds = [...new Set([...existingIds, lastAllergyId])]

                noteStructureRef.current = {
                  ...noteStructureRef.current,
                  metadata: {
                    ...noteStructureRef.current?.metadata,
                    allergiesIds: updatedIds,
                  },
                }
                console.log('Allergy ID added to note:', noteStructureRef)
              }
            }
          }
        } catch (err) {
          console.error('Error uploading allergies:', err)
          toast.error('Error uploading allergy data.', toastConfig)
        }
      }

      // Physical Examination
      const PEPatientData = UPdata[0]?.PEPatientData
      if (PEPatientData.length > 0) {
        PEPatientData.forEach(async (item) => {
          let response = await PatientPhysicalExaminationData('Insert', originalPatientId, item.NoteID, item?.Type, item?.JsonData)
        })
      }

      // HPI
      const patientHpi = await getPatientHpi()
      console.log(patientHpi, 'patientHpi')
      if (patientHpi.Data?.length > 0) {
        const filterToBeUpdated = patientHpi.Data.filter((item) => item.hpiStatus && item.ParsedJson[ID])
        console.log(filterToBeUpdated, 'filterToBeUpdated')
        if (filterToBeUpdated?.length > 0) {
          filterToBeUpdated.forEach(async (item) => {
            await SaveExtra('UPDATE', 'PatientHPI', item.JsonData, originalPatientId)
          })
        }
      }

      //   Upload Orders
      if (fetchUploadData?.ordersData?.length > 0) {
        try {
          const patientOrders = fetchUploadData.ordersData
          const APIType = await fetchOrders(originalPatientId)
          console.log('Fetched API Orders:', APIType, originalPatientId)

          for (const item of patientOrders) {
            if (item?.shouldUpdate) {
              await PatientOrdersCRUD('UPDATE', item?.id?.toString(), originalPatientId, item?.date, JSON.stringify(item?.medication), '', '')
            } else {
              await PatientOrdersCRUD('INSERT', '', originalPatientId, item?.date, JSON.stringify(item?.medication), '', '')
            }
          }
        } catch (err) {
          console.error('Error uploading orders:', err)
          toast.error('Error uploading patient orders.', toastConfig)
        }
      }

      //  Upload Patient Histories
      if (fetchUploadData?.patientHistories) {
        try {
          const histories = fetchUploadData.patientHistories
          const mapping = {
            fh: 'FamilyHistory',
            pmhx: 'MedicalHistory',
            pshx: 'SurgicalHistory',
            sh: 'SocialHistory',
          }

          for (const key in histories) {
            const historyType = mapping[key]
            const items = histories[key] || []

            for (const item of items) {
              const value = item[historyType]
              const date = item.Date || ''
              console.log('Uploading history:', originalPatientId, historyType, value)

              await getPatientPersonalHistory('INSERT', originalPatientId, historyType, '', value)
              const allData = await getPatientPersonalHistory('GET', originalPatientId, historyType, '')
              let formattedData = JSON.parse(allData?.d)?.Data || []

              if (formattedData?.length > 0) {
                const latestHistoryId = formattedData[formattedData.length - 1]?.Id
                noteStructureRef.current = {
                  ...noteStructureRef.current,
                  metadata: {
                    ...noteStructureRef.current.metadata,
                    [historyType]: latestHistoryId || '',
                  },
                }
              }
              console.log('Updated note with history:', noteStructureRef)
            }
          }
        } catch (err) {
          console.error('Error uploading histories:', err)
          toast.error('Error uploading patient histories.', toastConfig)
        }
      }

      // diagnosis add

      const diagnosisAdding = UPdata[0]?.finalDiagnosis
      if (diagnosisAdding) {
        console.log('UPDATE', originalPatientId, diagnosisAdding)
        await ModifyPatientMap('UPDATE', originalPatientId, diagnosisAdding)
      }

      /// SB Data
      if (fetchUploadData?.patientSuperBill && fetchUploadData?.patientSuperBill.length > 0) {
        try {
          const superBill = fetchUploadData?.patientSuperBill[fetchUploadData?.patientSuperBill.length - 1]
          console.log('super bill data submited')
          if (fetchUploadData?.updateAppointmentType && fetchUploadData?.updateAppointmentType.length > 0) {
            await handleUpdateAppointmentType(fetchUploadData?.updateAppointmentType[0])
          }
          await PatientSuperBillData('Insert', '', superBill?.JsonData, '', originalPatientId.toString())
        } catch (error) {
          console.error('Error in SuperBill:', error)
        }
      }

      console.log(fetchUploadData.currentNote, 'fetchUploadData.currentNote')
      //  Upload Current Note
      if (fetchUploadData?.currentNote) {
        try {
          const noteDetails = fetchUploadData.currentNote
           let patientDetails = noteDetails.patientDetails
            patientDetails = {
              ...noteDetails.patientDetails,
              PatientID:originalPatientId
            }
            console.log("patinet Id",noteDetails,patientDetails)
        
          const today = new Date()
          const formattedDateTime = today.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          })

          noteStructureRef.current = {
            ...noteStructureRef.current,
            signatureInfo: {
              signedTime: new Date().toISOString(),
              signedDate: new Date().toLocaleDateString('en-US'),
              signedTimeUs: new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
            },
            signedAt: formattedDateTime,
          }
          const formattedJson = JSON.stringify(noteStructureRef.current)

          console.log('Final note upload JSON:', noteStructureRef.current, formattedJson)

          if (appointmentNoteID) {
            console.log("appoinments dat----------------------> " , todaysAppointmentArray )
            const success = await handleAppointmentSubmit(appointmentNoteID, patientDetails,todaysAppointmentArray)
            if (success) {
              await handleAutoSchedule(patientDetails, appointmentNoteID ,todaysAppointmentArray)
              await PatientNoteDataCRUD('UPDATE', originalPatientId.toString(), patientNoteID, formattedJson, getFormattedDate().toString(), 'Signed', 'true')
              //  toast.success('Patient note signed and Auto-scheduled  successfully.', toastConfig)
            } else {
              toast.error('Appointment submission failed while uploading note.', toastConfig)
            }
          } else {
            toast.error('Missing appointment ID for current note.', toastConfig)
          }
        } catch (err) {
          console.error('Error uploading current note:', err)
          toast.error('Error uploading or signing patient note.', toastConfig)
        }
      }

      // update PatientDetails
      if (fetchUploadData?.patientEditData && Object.keys(fetchUploadData.patientEditData).length > 0) {
        const patientDetails = await fetchUploadData?.patientEditData
        console.log('patientDetails', patientDetails)

        try {
          await SavePatients('Update', patientDetails?.data, patientDetails?.facility, '',  originalPatientId, patientDetails?.insurances)
        } catch (error) {
          console.error('error occured', error)
        }
       }

       }
       
       else{
       const reports = UPdata[0]?.reportData
      const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous']
      const getFileExtension = (file) => {
        if (!file || !file.name) return ''
        return file.name.split('.').pop().toLowerCase()
      }

      Object.entries(reports).forEach(([key, value]) => {
        const filterIsToUpload = value.filter((item) => item.isToUpload)
        console.log(filterIsToUpload, 'filterIsToUpload')
        if (filterIsToUpload.length > 0) {
          filterIsToUpload.forEach(async (fileObj) => {
            try {
              const formData = new FormData()
              const fileObject = fileObj?.data[0].file
              console.log(fileObject, 'fileObject')
              formData.append('file', fileObject)
              formData.append('upload_preset', 'provio')
              formData.append('folder', 'provio')

              // Decide resource type
              let resourceType = 'auto'
              if (getFileExtension(fileObject).includes('pdf') || getFileExtension(fileObject).includes('msword')) {
                resourceType = 'raw'
              }

              // Upload to Cloudinary
              const uploadRes = await fetch(`https://api.cloudinary.com/v1_1/dxayiclcq/${resourceType}/upload`, {
                method: 'POST',
                body: formData,
              })

              const uploadData = await uploadRes.json()

              const uploadedFileUrl = uploadData.secure_url
              const publicId = uploadData.public_id
              let uploadedFileType = uploadData.resource_type
              let assetId = uploadData.asset_id

              const payload = [
                {
                  url: uploadData.secure_url,
                  type: uploadData.resource_type,
                  fileName: fileObject.fileName,
                  id: uploadData.asset_id || Date.now(),
                  publicId: uploadData.public_id,
                },
              ]
              const jsonFormat = JSON.stringify(payload)

              await PatientReportCRUD('INSERT', ID?.toString(), '', key?.toString(), jsonFormat, getFormattedDate().toString())
            } catch (err) {
              console.error('Upload failed for', fileObj.fileName, err)
            }
          })
        }
        const filterToBeDeleted = value.filter((item) => item.isToBeDeleted)
        console.log(filterToBeDeleted, 'filterToBeDeleted')
        if (filterToBeDeleted.length > 0) {
          filterToBeDeleted.forEach(async (fileObj) => {
            try {
              await PatientReportCRUD('DELETE', ID?.toString(), fileObj.id)
            } catch (err) {
              console.error('Delete failed for', fileObj.fileName, err)
            }
          })
        }
      })

      // Load Current Note Datas

      if (fetchUploadData?.currentNote) {
        try {
          // const parsed = JSON.parse(fetchUploadData?.currentNote?.formateData)
          const parsed = getNoteRefData.data
          noteStructureRef.current = parsed
        } catch (err) {
          console.error('Error parsing current note:', err)
          toast.error('Failed to parse current note data.', toastConfig)
        }
      }

      console.log('noteStructureRef.current --->', noteStructureRef.current)
      //   Upload Allergies
      if (fetchUploadData?.patientAllergy?.length > 0) {
        try {
          for (const item of fetchUploadData.patientAllergy) {
            await GetPatientAllergiesCRUD('INSERT', item?.patientID?.toString(), item?.data, '', getFormattedDate())

            const allAllergies = await fetchAllergies(ID)
            console.log('Fetched allergies:', allAllergies)

            if (allAllergies?.length > 0) {
              const lastAllergyId = allAllergies[allAllergies.length - 1]?.id
              if (lastAllergyId) {
                const existingIds = noteStructureRef.current?.metadata?.allergiesIds || []
                const updatedIds = [...new Set([...existingIds, lastAllergyId])]

                noteStructureRef.current = {
                  ...noteStructureRef.current,
                  metadata: {
                    ...noteStructureRef.current?.metadata,
                    allergiesIds: updatedIds,
                  },
                }
                console.log('Allergy ID added to note:', noteStructureRef)
              }
            }
          }
        } catch (err) {
          console.error('Error uploading allergies:', err)
          toast.error('Error uploading allergy data.', toastConfig)
        }
      }

      // Physical Examination
      const PEPatientData = UPdata[0]?.PEPatientData
      if (PEPatientData.length > 0) {
        PEPatientData.forEach(async (item) => {
          let response = await PatientPhysicalExaminationData('Insert', item?.patientID, item.NoteID, item?.Type, item?.JsonData)
        })
      }

      // HPI
      const patientHpi = await getPatientHpi()
      console.log(patientHpi, 'patientHpi')
      if (patientHpi.Data?.length > 0) {
        const filterToBeUpdated = patientHpi.Data.filter((item) => item.hpiStatus && item.ParsedJson[ID])
        console.log(filterToBeUpdated, 'filterToBeUpdated')
        if (filterToBeUpdated?.length > 0) {
          filterToBeUpdated.forEach(async (item) => {
            await SaveExtra('UPDATE', 'PatientHPI', item.JsonData, item?.Id)
          })
        }
      }

      //   Upload Orders
      if (fetchUploadData?.ordersData?.length > 0) {
        try {
          const patientOrders = fetchUploadData.ordersData
          const APIType = await fetchOrders(ID)
          console.log('Fetched API Orders:', APIType, ID)

          for (const item of patientOrders) {
            if (item?.shouldUpdate) {
              await PatientOrdersCRUD('UPDATE', item?.id?.toString(), ID, item?.date, JSON.stringify(item?.medication), '', '')
            } else {
              await PatientOrdersCRUD('INSERT', '', ID, item?.date, JSON.stringify(item?.medication), '', '')
            }
          }
        } catch (err) {
          console.error('Error uploading orders:', err)
          toast.error('Error uploading patient orders.', toastConfig)
        }
      }

      //  Upload Patient Histories
      if (fetchUploadData?.patientHistories) {
        try {
          const histories = fetchUploadData.patientHistories
          const mapping = {
            fh: 'FamilyHistory',
            pmhx: 'MedicalHistory',
            pshx: 'SurgicalHistory',
            sh: 'SocialHistory',
          }

          for (const key in histories) {
            const historyType = mapping[key]
            const items = histories[key] || []

            for (const item of items) {
              const value = item[historyType]
              const date = item.Date || ''
              console.log('Uploading history:', ID, historyType, value)

              await getPatientPersonalHistory('INSERT', ID, historyType, '', value)
              const allData = await getPatientPersonalHistory('GET', ID, historyType, '')
              let formattedData = JSON.parse(allData?.d)?.Data || []

              if (formattedData?.length > 0) {
                const latestHistoryId = formattedData[formattedData.length - 1]?.Id
                noteStructureRef.current = {
                  ...noteStructureRef.current,
                  metadata: {
                    ...noteStructureRef.current.metadata,
                    [historyType]: latestHistoryId || '',
                  },
                }
              }
              console.log('Updated note with history:', noteStructureRef)
            }
          }
        } catch (err) {
          console.error('Error uploading histories:', err)
          toast.error('Error uploading patient histories.', toastConfig)
        }
      }

      // diagnosis add

      const diagnosisAdding = UPdata[0]?.finalDiagnosis
      if (diagnosisAdding) {
        console.log('UPDATE', ID, diagnosisAdding)
        await ModifyPatientMap('UPDATE', ID, diagnosisAdding)
      }

      /// SB Data
      if (fetchUploadData?.patientSuperBill && fetchUploadData?.patientSuperBill.length > 0) {
        try {
          const superBill = fetchUploadData?.patientSuperBill[fetchUploadData?.patientSuperBill.length - 1]
          console.log('super bill data submited')
          if (fetchUploadData?.updateAppointmentType && fetchUploadData?.updateAppointmentType.length > 0) {
            await handleUpdateAppointmentType(fetchUploadData?.updateAppointmentType[0])
          }
          await PatientSuperBillData('Insert', '', superBill?.JsonData, '', ID.toString())
        } catch (error) {
          console.error('Error in SuperBill:', error)
        }
      }

      console.log(fetchUploadData.currentNote, 'fetchUploadData.currentNote')
      //  Upload Current Note
      if (fetchUploadData?.currentNote) {
        try {
          const noteDetails = fetchUploadData.currentNote
          const today = new Date()
          const formattedDateTime = today.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          })

          noteStructureRef.current = {
            ...noteStructureRef.current,
            signatureInfo: {
              signedTime: new Date().toISOString(),
              signedDate: new Date().toLocaleDateString('en-US'),
              signedTimeUs: new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
            },
            signedAt: formattedDateTime,
          }
          const formattedJson = JSON.stringify(noteStructureRef.current)

          console.log('Final note upload JSON:', noteStructureRef.current, formattedJson)

          if (noteDetails?.appointmentId) {
            const success = await handleAppointmentSubmit(noteDetails.appointmentId, noteDetails.patientDetails , appointments)
            if (success) {
              await handleAutoSchedule(noteDetails.patientDetails, noteDetails.appointmentId , appointments)
              await PatientNoteDataCRUD('UPDATE', ID.toString(), noteDetails.id, formattedJson, getFormattedDate().toString(), 'Signed', 'true')
              //  toast.success('Patient note signed and Auto-scheduled  successfully.', toastConfig)
            } else {
              toast.error('Appointment submission failed while uploading note.', toastConfig)
            }
          } else {
            toast.error('Missing appointment ID for current note.', toastConfig)
          }
        } catch (err) {
          console.error('Error uploading current note:', err)
          toast.error('Error uploading or signing patient note.', toastConfig)
        }
      }

      // update PatientDetails
      if (fetchUploadData?.patientEditData && Object.keys(fetchUploadData.patientEditData).length > 0) {
        const patientDetails = await fetchUploadData?.patientEditData
        console.log('patientDetails', patientDetails)

        try {
          await SavePatients('Update', patientDetails?.data, patientDetails?.facility, '', patientDetails?.patientID, patientDetails?.insurances)
        } catch (error) {
          console.error('error occured', error)
        }
      }

       }



 
     
      //  Final Success
    
    
      toast.success('Patient data uploaded successfully to the server.', toastConfig)
      await updatePatientUploadStatus(ID)
    } catch (error) {
      console.error('Error in uploadPatient:', error)
      toast.error('Unexpected error occurred while uploading patient data.', toastConfig)
    } finally {
       if (useLoaderState) {
         setDownloadingData(false)
       }
     
    }
  }

  useEffect(() => {
    getFacilities()
    getProviders()
    getFacilitiesAppointment()
    getProvidersMaster()
  }, [])

  // useEffect(() => {
  //   if (downloadingData) {
  //     setProgress(0)
  //     const startTime = Date.now()
  //     const duration = 2000 // 2 seconds
  //     const interval = setInterval(() => {
  //       const elapsed = Date.now() - startTime
  //       const percent = Math.min((elapsed / duration) * 100, 100)
  //       setProgress(percent)
  //       if (percent >= 100) {
  //         clearInterval(interval)
  //         setTimeout(() => setDownloadingData(false), 200)
  //         // toast.success('Patient data uploaded successfully to the server.', toastConfig)
  //       }
  //     }, 50)
  //     return () => clearInterval(interval)
  //   } else {
  //     setProgress(0)
  //   }
  // }, [downloadingData])

  useEffect(() => {
    let timer

    if (downloadingData) {
      setProgress(0)

      timer = setInterval(() => {
        setProgress((prev) => {
          const next = prev + 2
          return next >= 95 ? 95 : next
        })
      }, 100)
    } else {
      setProgress(100)
    }

    return () => clearInterval(timer)
  }, [downloadingData])

  console.log("downloading data", downloadingData)

  useEffect(() => {
    const fetchAppointmentData = async () => {
      const getAppointmentData = await getAllAppointmentsDetails('GET')
      setAppointments(getAppointmentData)
    }
    fetchAppointmentData()
  }, [])

   
  const uploadAllPatientData = async()=> {
    setDownloadingData(true)
    for (const item of patients) {
      console.log('item', item)
      await uploadPatient(item.PatientID ,  false)
    }
     setDownloadingData(false)
  }


  return (
    <>
      <div className=" mx-3 ">
        <div className="testdiv provider-page " style={{ width: '' }}>
          <CButton
            className="d-flex align-items-center gap-2"
            style={{
              backgroundColor: 'inherit',
              border: `1px solid #333`,
              height: '40px',
              padding: '5px 14px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              color: '#fff',
              fontWeight: '500',
              fontSize: '14px',
              boxShadow: 'none',
            }}
            variant="outlined"
            size="large"
            onClick={() => uploadAllPatientData()}
          >
            <Upload size={20} strokeWidth={1.5} />
            Upload All
          </CButton>
          <div className="border-bottom-0 border-0 w-100 mt-2">
            <div className={`accordion-wrapper border-bottom-0 border-0 p-0 shadow-sm accordion-dark`} style={{ borderRadius: '40px!important' }}>
              <CAccordion alwaysOpen className="border-bottom-0 border-0 p-0 homeAccordion ">
                <CTable responsive className=" mb-3 border-bottom-0 border-0  ">
                  <CTableBody className="">
                    {patients.length > 0 ?
                      patients.map((patient, index) => {
                        return (
                          <CTableRow
                            className="order-0 patient-row-shadow"
                            key={patient.PatientID}
                            onClick={() => {
                              setSelectedPatientId(patient.PatientID)
                            }}
                            style={{
                              cursor: 'pointer',
                              verticalAlign: 'middle',
                              gap: '20px',
                              margin: '10px 2px',
                              background: '#1E1E1E',
                              boxShadow: selectedPatientId === patient.PatientID ? '0 0 10px #ffffff' : '0 0 4px rgba(0, 0, 0, 0.5)',
                              borderRadius: '6px',
                              transition: 'all 0.25s ease-in-out',
                            }}
                            onMouseEnter={(e) => {
                              if (selectedPatientId !== patient.PatientID) {
                                e.currentTarget.style.boxShadow = '0 0 8px rgba(255,255,255,0.2)'
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (selectedPatientId !== patient.PatientID) {
                                e.currentTarget.style.boxShadow = '0 0 4px rgba(0, 0, 0, 0.5)'
                              }
                            }}
                          >
                            <CTableDataCell className="border-bottom-0 border-0 p-0" scope="row">
                              <span className="patient-name-fixed d-flex align-items-center gap-2 text-white" style={{ fontWeight: '100' }}>
                                <span
                                  style={{
                                    width: '10px',
                                    height: '10px',
                                    background: patient?.Status === 'NewPatient' ? 'green' : patient?.Status === 'Follow Up' ? 'orange' : 'gray',
                                    display: 'block',
                                    borderRadius: '50px',
                                  }}
                                ></span>
                                {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                              </span>
                            </CTableDataCell>
                            <CTableDataCell className="d-flex align-items-center justify-content-end border-bottom-0 border-0">
                              <span className="room-pill"> Room : {patient?.Room}</span>
                              {patient?.patientSeen === false && <span className="schedule1-pill">Not Seen : {patient?.notSeenReason}</span>}

                              {downloadingData ? <Loader2 className="animate-spin" style={{ color: 'white', width: '18px', height: '18px' }} /> : <Upload onClick={() => uploadPatient(patient.PatientID)} style={{ color: 'white', width: '18px', height: '18px', cursor: 'pointer' }} />}
                            </CTableDataCell>
                          </CTableRow>
                        )
                      }) :
                      <div className="d-flex justify-content-center align-items-start text-muted">
                        <div
                          style={{
                            padding: '40px',
                            fontSize: '15px',
                            fontWeight: '600px',
                            color: 'gray',
                          }}
                        >
                         No Signed Patients available to upload
                        </div>
                      </div>
                    
                    }


                  </CTableBody>
                </CTable>
              </CAccordion>
            </div>
          </div>
        </div>
      </div>

      <CModal backdrop="static" size="lg" alignment="center" visible={downloadingData} onClose={() => setDownloadingData(false)}>
        <CModalBody
          style={{
            backgroundColor: '#191919',
            color: 'white',
          }}
        >
          <div className="text-center">
            <div className="d-flex align-items-center justify-content-center mb-3">
              <CAvatar src={logo} className="rounded-0" style={{ width: '90px', height: '90px' }} />
              <span
                style={{
                  color: '#4FC3F7',
                  fontSize: '18px',
                  marginLeft: '1px',
                }}
              >
                Provio Solutions
              </span>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '20px' }}>
              <div style={{ width: '60%' }}>
                {' '}
                <CProgress height={5} className="mt-3" style={{ backgroundColor: '#333' }}>
                  <CProgressBar value={progress} color="info" animated />
                </CProgress>
                <p style={{ marginTop: '5px', color: '#aaa' }}>Uploading data - {Math.round(progress)}%</p>{' '}
              </div>
            </div>
          </div>
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#191919',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton
            onClick={() => {
              cancelRequested.current = true
              setDownloadingData(false)
            }}
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            variant="outline"
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default UploadOpenChartPatient
